import type { AuthConfigStatus } from './smartcaptcha';

type Props = {
  enabled: boolean;
  challengeVisible?: boolean;
  /** loading/error показывают состояние конфига; по умолчанию — готово. */
  status?: AuthConfigStatus;
  onRetry?: () => void;
};

/**
 * Уведомление об обработке данных SmartCaptcha (обязательно по правилам сервиса).
 * В невидимом режиме штатный щит Яндекса скрыт (hideShield) — уведомление показываем здесь.
 * Пока конфиг грузится, submit блокируется и здесь видна подсказка; при ошибке — кнопка повтора.
 */
export function SmartCaptchaNotice({ enabled, challengeVisible, status = 'ready', onRetry }: Props) {
  if (status === 'ready' && !enabled) return null;
  return (
    <div className="space-y-1 text-center">
      {status === 'loading' ? (
        <p className="m-0 text-xs text-[hsl(var(--ui-muted-foreground))]" role="status" aria-live="polite">
          Проверяем защиту от роботов…
        </p>
      ) : null}
      {status === 'error' ? (
        <p className="m-0 text-xs text-[hsl(var(--ui-muted-foreground))]" role="status" aria-live="polite">
          Не удалось проверить защиту от роботов.{' '}
          {onRetry ? (
            <button
              type="button"
              className="underline underline-offset-2 hover:text-[hsl(var(--ui-foreground))]"
              onClick={onRetry}
            >
              Повторить
            </button>
          ) : null}
        </p>
      ) : null}
      {status === 'ready' && challengeVisible ? (
        <p className="m-0 text-xs text-[hsl(var(--ui-foreground))]" role="status" aria-live="polite">
          Пройдите проверку, чтобы продолжить.
        </p>
      ) : null}
      {status === 'ready' ? (
        <p className="m-0 text-[11px] leading-snug text-[hsl(var(--ui-muted-foreground))]">
          Защищено{' '}
          <a
            href="https://yandex.ru/legal/smartcaptcha_notice/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2"
          >
            Yandex SmartCaptcha
          </a>
        </p>
      ) : null}
    </div>
  );
}
